































import BaseComponent from '@/components/base-component.vue';
import { registerFingerprint } from '@/services/webauthn';
import Component from 'vue-class-component';

@Component({
  components: {},
  directives: {}
})
export default class RegisterFingerprintDialog extends BaseComponent {
  dialogFlag = false;
  formOpen = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  public rules: any = {};

  public form: any = {
    valid: false
  };

  public beforeMount(): void {}

  mounted() {
    this.formOpen = true;
    setTimeout(() => {
      this.$refs['btnConfirma'].$el.focus();
    }, 250);
  }

  closeForm() {
    this.$emit('close');
    this.dialogFlag = false;
  }

  save() {
    this.loader.start("Processando ...");
    registerFingerprint()
      .then((r) => {
        this.toast.show(r, 'success');
      })
      .catch((error) => {
        this.toast.show("Não foi possível cadastrar a biometria", "error");
      })
      .finally(() => {
        this.loader.stop();
        this.$emit('close');
        this.dialogFlag = false;
      });
  }
}
